<template>
	<div>
		<toolbar>

			<h2>
				<i class="fa fa-clipboard-check"></i>
				Forms
			</h2>

			<div class="controls">
				<slot></slot>
				<nav-tabs
					:mobile-breakpoint="1024"
					:tabs="[
						{
							label: 'Templates',
							path: '/forms/templates',
							icon: 'fa-clipboard-check'
						},
						{
							label: 'List',
							path: '/forms/list',
							icon: 'fa-list'
						},
						{
							label: 'Marketplace',
							path: '/forms/marketplace',
							icon: 'fa-store'
						}
					]"></nav-tabs>
			</div>
		</toolbar>

	</div>
</template>
<script type="text/javascript">
import NavTabs from "@/layout_fragments/NavTabs"
import Toolbar from "@/layout_fragments/Toolbar"

export default {
	name: "FormToolbar",
	components: {
		NavTabs,
		Toolbar
	}
}
</script>